import { requestSubmitButtonValidation } from '../../hop-registration-form/js/request-submit-button-validation';

export const dobDisclaimerElementIds = {
  checkbox: 'dob-integrity-disclaimer',
  validationMessage: 'DobIntegrityDisclaimer',
};

export const dobDisclaimerErrorText = "Confirm you understand you could get a fine or other penalties by entering the wrong date of birth to claim discounts you're not eligible for.";

function getCheckboxElement() {
  return document.getElementById(dobDisclaimerElementIds.checkbox);
}

function isAtCheckboxElement(element) {
  return element?.tagName === 'AT-CHECKBOX';
}

function getCheckboxInput(element) {
  if (!element) return null;

  if (element.matches?.('input[type="checkbox"]')) {
    return element;
  }

  return element.querySelector?.('input[type="checkbox"]');
}

function getCheckboxChecked(checkbox) {
  const input = getCheckboxInput(checkbox);
  if (input) {
    return input.checked;
  }

  if (typeof checkbox.checked === 'boolean') {
    return checkbox.checked;
  }

  return false;
}

function getValidationMessageElement() {
  return document.querySelector(`[data-valmsg-for="${dobDisclaimerElementIds.validationMessage}"]`);
}

function showLegacyCheckboxError(checkbox) {
  const input = getCheckboxInput(checkbox);
  const errorEl = getValidationMessageElement();

  if (errorEl) {
    errorEl.textContent = dobDisclaimerErrorText;
    errorEl.classList.remove('field-validation-valid');
    errorEl.classList.add('field-validation-error');
  }

  input?.classList.add('input-validation-error');
  (input ?? checkbox).scrollIntoView?.({ behavior: 'smooth', block: 'center' });
}

function hideLegacyCheckboxError(checkbox) {
  const input = getCheckboxInput(checkbox);
  const errorEl = getValidationMessageElement();

  if (errorEl) {
    errorEl.textContent = '';
    errorEl.classList.remove('field-validation-error');
    errorEl.classList.add('field-validation-valid');
  }

  input?.classList.remove('input-validation-error');
}

function showCheckboxError() {
  const checkbox = getCheckboxElement();
  if (!checkbox) return;

  if (isAtCheckboxElement(checkbox)) {
    checkbox.errorText = dobDisclaimerErrorText;
    checkbox.showError = true;
    checkbox.componentState = 'error';
    checkbox.setAttribute('show-error', '');
    checkbox.setAttribute('component-state', 'error');
    checkbox.setAttribute('error-text', dobDisclaimerErrorText);
    checkbox.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
    return;
  }

  showLegacyCheckboxError(checkbox);
}

function hideCheckboxError() {
  const checkbox = getCheckboxElement();
  if (!checkbox) return;

  if (isAtCheckboxElement(checkbox)) {
    checkbox.showError = false;
    checkbox.componentState = 'enabled';
    checkbox.removeAttribute('show-error');
    checkbox.setAttribute('component-state', 'enabled');
    return;
  }

  hideLegacyCheckboxError(checkbox);
}

/**
 * Binds DOB integrity disclaimer validation to a form.
 * Supports Design System Next <at-checkbox> and legacy checkbox markup.
 * No-op when the checkbox is not present.
 *
 * @param {HTMLFormElement | null} form
 * @returns {{ bound: boolean, isValid: () => boolean }}
 */
export function bindDobDisclaimerValidation(form) {
  const checkbox = getCheckboxElement();

  if (!form || !checkbox) {
    return { bound: false, isValid: () => true };
  }

  const handleChange = (event) => {
    const checked = event.detail?.checked ?? getCheckboxChecked(checkbox);
    if (checked) {
      hideCheckboxError();
    }
    requestSubmitButtonValidation();
  };

  if (isAtCheckboxElement(checkbox)) {
    checkbox.addEventListener('atChange', handleChange);
  } else {
    getCheckboxInput(checkbox)?.addEventListener('change', handleChange);
  }

  return {
    bound: true,
    isValid: () => {
      if (getCheckboxChecked(checkbox)) {
        hideCheckboxError();
        return true;
      }

      showCheckboxError();
      return false;
    },
  };
}
